import Vue from 'vue';

const SET_META = 'SET_META';
const UNSET_META = 'UNSET_META';

export default {
  namespaced: true,
  state: {
    meta: null,
  },
  mutations: {
    /* eslint-disable no-param-reassign */
    [SET_META](state, meta) {
      state.meta = meta;
    },
    [UNSET_META](state) {
      state.meta = null;
    },
    /* eslint-enable no-param-reassign */
  },
  actions: {
    getMetas(context, params) {
      return Vue.axios.get('metas', {
        params,
      });
    },
    getMeta({ commit }, id) {
      return Vue.axios.get(`metas/${id}`)
        .then(({ data }) => commit(SET_META, data));
    },
    unsetMeta({ commit }) {
      commit(SET_META);
    },
    saveMeta({ commit }, data) {
      const { id } = data;
      const method = id ? 'put' : 'post';
      const url = id ? `metas/${id}` : 'metas';

      return Vue.axios({
        method,
        url,
        data,
      }).then((response) => {
        commit(SET_META, response.data);
        return new Promise(resolve => resolve(response.data));
      });
    },
  },
  getters: {
    meta: state => state.meta,
  },
};
